import React from "react";
import { PageTitle } from "@/components/SettingsPanel";
import { TeamManager } from "@/components/TeamManager";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";
import type { User } from "@/types";

const CFG = { base: "/venue/team", roleKey: "venue_role" as const, roles: ["owner", "reception", "finance"], prefix: "venue" };

export default function VenueTeam() {
  const { t } = usePrefs();
  const me = useAuth().user as User;
  const isOwner = me.venue_role === "owner";
  return (
    <div data-testid="venue-team-page">
      <PageTitle title={t("team.title")} sub={isOwner ? t("team.sub") : t("team.ownerOnly")} />
      <TeamManager cfg={CFG} canManage={isOwner} />
    </div>
  );
}
